import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Attach token from localStorage as fallback (cookies also work)
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("zen_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    const msg = e?.response?.data?.detail;
    const url = e?.config?.url || "";
    if (e?.response?.status === 401) {
      // silent - auth routes and settings handle their own errors
      const skip = url.includes("/auth/") || url.includes("/settings");
      if (!skip) {
        localStorage.removeItem("zen_token");
        window.dispatchEvent(new Event("zen:unauth"));
      }
    } else if (msg && typeof msg === "string") {
      toast.error(msg);
    }
    return Promise.reject(e);
  }
);

export default api;
